import { useParams } from "react-router-dom";
import { useGetBookQuery } from "../../features/api/apiSlice";
import Form from "./Form";

export default function EditBook() {
  const { bookId } = useParams();
  const { data: book, isLoading, isError } = useGetBookQuery(bookId);

  // decide what to render
  let content = null;
  if (isLoading) content = <div className="text-center">Loading .... </div>;
  if (!isLoading && isError) content = <div className="text-center" style={{color:"red"}}>There was an error</div>;
  if (!isLoading && !isError && book?.id) content = <Form book={book} />;

  return (
    <div className="p-8 overflow-hidden bg-white shadow-cardShadow rounded-md max-w-xl mx-auto">
      <h4 className="mb-8 text-xl font-bold text-center">Edit Book</h4>
      {content}
    </div>
  );
}
